import { createFileRoute, redirect } from '@tanstack/react-router';

// Agent-first /admin default (PHO-14243 §1). The old grid landing
// lived at /admin/organizations; that page is unchanged and still
// reachable directly. Anyone who bookmarked /admin lands in the
// full-page chat experience.
export const Route = createFileRoute('/_app/admin/')({
    beforeLoad: () => redirect({ to: '/admin/agent', replace: true }),
    component: () => null,
});
